import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Redirect } from 'react-router-dom';

import { currentUserIsAdminType, currentUserIsManager, getBrowserName, setCookie, getCookie, isUnsupportedDevice, isUnsupportedBrowser, isLocalhost } from '../../util';

import { getIcon, getBrowserIcon } from '../../util/icons';

import { updateUser } from '../../actions/users';

class WelcomeModal extends Component{

  state = {
    currentStep: 1,
    welcomeComplete: false,
    visible: false,
  }

  userShouldSeeModal(){
    const userIsManager = currentUserIsManager();

    //For local testing only
    // return isLocalhost();

    if(currentUserIsAdminType()){
      return false;
    }
    else if(userIsManager){
      //cookie not set AND welcomeModalSkipped prop not set on user
      if(getCookie('velocity_v0_manager_welcome_completed') !== 'YES' && this.props.user && !this.props.user.welcomeModalSkipped){
        return true;
      }
    }
    else if(!userIsManager){
      //cookie not set AND welcomeModalSkipped prop not set on user
      if(getCookie('velocity_v0_rep_welcome_completed') !== 'YES' && this.props.user && !this.props.user.welcomeModalSkipped){
        return true;
      }
    }

    return false;
  }

  competenciesEnabled(){
    console.log('competenciesEnabled: ', this.props.organization.competenciesEnabled);
    return this.props.organization && this.props.organization.competenciesEnabled;
  }

  componentWillMount(){
    // console.log('getBrowserName: ', getBrowserName());
    // console.log('getCookie(velocity_v0_manager_welcome_completed)');
    // console.log(getCookie('velocity_v0_manager_welcome_completed'));
    // console.log('currentUserIsManager: ', currentUserIsManager() ? 'yes' : 'no');

    const TEST_WELCOME_MODALS = false;

    if(TEST_WELCOME_MODALS || this.userShouldSeeModal()){
      this.setState({
        visible: true
      });
    }
  }

  coachingIQDisabled(){
    return (this.props.organization || {}).coachingIQDisabled;
  }

  finishWelcome(){
    //set welcome completed in cookies!
    setCookie((currentUserIsManager() ? 'velocity_v0_manager_welcome_completed' : 'velocity_v0_rep_welcome_completed'), 'YES');

    //then set visible to false and redirect
    this.setState({
      visible: false,
      welcomeComplete: true
    });
  }

  resetScroll(){
    console.log('resetting scroll!');
    //this.container.scrollTop = '0px';
    window.scrollTo(0, 0);
  }

  prev(){
    this.setState({
      currentStep: this.state.currentStep - 1
    });
    setTimeout(this.resetScroll.bind(this), 50);
  }

  next(){
    this.setState({
      currentStep: this.state.currentStep + 1
    });
    setTimeout(this.resetScroll.bind(this), 50);
  }

  renderQuarterlyPreview(){
    if(currentUserIsManager()){
      return (
        <div className="modal-content">
          <div className="message-icons">
            <div className="message-icon active">{getIcon('talents')}</div>
            <div className="message-icon">{getIcon('sprint')}</div>
            <div className="message-icon">{getIcon('imperatives')}</div>
          </div>
          {this.competenciesEnabled() &&
            <React.Fragment>
              <h2>Step 1: Sales Competency Inventory (1-2 Times per year)</h2>
              <p>The first step of the Velocity Sales process is to get a sense of the strengths and weaknesses of your salespeople. Both you and your reps will complete a Sales Competency Inventory. This will set a baseline for behaviors and sales skills which they can improve.</p>
              <p>Having a sense of where their selling skills lie will also help you select which areas you'd like your team to focus on improving each quarter.</p>
            </React.Fragment>
          }
          {!this.competenciesEnabled() &&
            <React.Fragment>
              <h2>Step 1: Talent Evaluation (Quarterly)</h2>
              <p>The first step of the Velocity Sales process is to get a sense of the strengths and weaknesses of your salespeople. Both you and your reps will complete a talent evaluation. This will set a baseline for behaviors and sales skills which they can improve.</p>
              <p>Having a sense of where their talents lie will also help you select which areas you'd like your team to focus on improving each quarter.</p>
            </React.Fragment>
          }
        </div>
      )
    }
    else{
      return (
        <div className="modal-content">
          <div className="message-icons">
            <div className="message-icon active">{getIcon('talents')}</div>
            <div className="message-icon">{getIcon('sprint')}</div>
            <div className="message-icon">{getIcon('imperatives')}</div>
          </div>
          {this.competenciesEnabled() &&
            <React.Fragment>
              <h2>Step 1: Talent Assessment & Sales Competency Inventory (1-2 Times per year)</h2>
              <p>The first step of the Velocity Sales process is to get a sense of where your strengths and weaknesses are. You will first be tasked with completing a Talent Assessment. This will generate a personal profile of where your natural talents and selling capabilities lie.</p>
              <p>Both you and your manager will also complete a Sales Competency Inventory, which will further illuminate your selling skills and set a baseline for specific selling competenices and critical expertise components.</p>
              <p>You and your manager will then use these results to determine which areas to focus on improving each quarter.</p>
            </React.Fragment>
          }
          {!this.competenciesEnabled() &&
            <React.Fragment>
              <h2>Step 1: Talent Evaluation (Quarterly)</h2>
              <p>The first step of the Velocity Sales process is to get a sense of where your strengths and weaknesses are. Both you and your manager will complete a talent evaluation. This will set a baseline for behaviors and sales skills where you can improve.</p>
              <p>Having a sense of where your talents lie will also help you and your manager select which areas you'd like to focus on improving each quarter.</p>
            </React.Fragment>
          }
        </div>
      )
    }
  }

  renderWeeklyPreview(){
    if(currentUserIsManager()){
      return (
        <div className="modal-content">
          <div className="message-icons">
            <div className="message-icon">{getIcon('talents')}</div>
            <div className="message-icon active">{getIcon('sprint')}</div>
            <div className="message-icon">{getIcon('imperatives')}</div>
          </div>
          <h2>Step 2: Velocity Sprint (Weekly)</h2>
          {this.competenciesEnabled() &&
            <React.Fragment>
              <p>The second step of the Velocity Sales process is the weekly sprint process. To begin the quarter, you'll select selling competencies, areas of critial expertise, and activities for your salespeople to work on every week.</p>
              <p>At the end of each week, you'll receive a report from each of your salespeople and will review their progress on the following Monday. These Monday meetings are a valuable time to provide coaching and guidance on their plan for the following week.</p>
            </React.Fragment>
          }
          {!this.competenciesEnabled() &&
            <React.Fragment>
              <p>The second step of the Velocity Sales process is the weekly sprint process. To begin the quarter, you'll select behaviors, skills, and activities for your salespeople to work on every week.</p>
              <p>At the end of each week, you'll receive a report from each of your salespeople and will review their progress on the following Monday. These Monday meetings are a valuable time to provide coaching and guidance on their plan for the following week.</p>
            </React.Fragment>
          }
        </div>
      )
    }
    else{
      return (
        <div className="modal-content">
          <div className="message-icons">
            <div className="message-icon">{getIcon('talents')}</div>
            <div className="message-icon active">{getIcon('sprint')}</div>
            <div className="message-icon">{getIcon('imperatives')}</div>
          </div>
          <h2>Step 2: Velocity Sprint (Weekly)</h2>
          {this.competenciesEnabled() &&
            <React.Fragment>
              <p>The second step of the Velocity Sales process is the weekly sprint process. Every week you'll be tasked with working on the selling competencies and areas of critical expertise you and your manager selected, as well as completing activites and updating your quarterly sales forecast.</p>
              <p>At the end of each week, you'll submit your report to your manager and he or she will review with you the following Monday. These Monday meetings give you dedicated time with your manager to review progress on your goals and discuss your action plan for the following week.</p>
            </React.Fragment>
          }
          {!this.competenciesEnabled() &&
            <React.Fragment>
              <p>The second step of the Velocity Sales process is the weekly sprint process. Every week you'll be tasked with working on the behaviors and skills you selected, as well as completing activites and updating your quarterly sales forecast.</p>
              <p>At the end of each week, you'll submit your report to your manager and he or she will review with you the following Monday. These Monday meetings give you dedicated time with your manager to review progress on your goals and discuss your action plan for the following week.</p>
            </React.Fragment>
          }
        </div>
      )
    }
  }

  renderDailyPreview(){
    if(currentUserIsManager()){
      return (
        <div className="modal-content">
          <div className="message-icons">
            <div className="message-icon">{getIcon('talents')}</div>
            <div className="message-icon">{getIcon('sprint')}</div>
            <div className="message-icon active">{getIcon('imperatives')}</div>
          </div>
          <h2>Step 3: Seven Imperatives (Daily)</h2>
          <p>The last step of the Velocity Sales process is working through the Seven Imperatives process for each deal. Your salespeople should be updating win cards for each opportunity daily.{/*This gives you the ability to know where every deal is at, identify problem areas, and coach your salespeople to victory.*/}</p>
          <p>When your salespeople use the Seven Imperatives framework for each every opportunity, you'll gain valuable insights into deal progress, can quickly identify risks, and will be able to coach and communicate more effectively.</p>
        </div>
      )
    }
    else{
      return (
        <div className="modal-content">
          <div className="message-icons">
            <div className="message-icon">{getIcon('talents')}</div>
            <div className="message-icon">{getIcon('sprint')}</div>
            <div className="message-icon active">{getIcon('imperatives')}</div>
          </div>
          <h2>Step 3: Seven Imperatives (Daily)</h2>
          <p>The last step of the Velocity Sales process is working through the Seven Imperatives process for each deal. You should be updating each Seven Imperatives "Win Card" as you make progress on each Opportunity.</p>
          <p>Using the Seven Imperatives framework for each of your opportunities is proven to help you sell more effectively, and gives you a common language for communicating deal progress and risks with leaders and colleagues.</p>
        </div>
      )
    }
  }

  renderSevenImperativesPreview(){
    if(currentUserIsManager()){
      return (
        <div className="modal-content">
          <div className="message-icons">
            <div className="message-icon active">{getIcon('imperatives')}</div>
          </div>
          <h2>Seven Imperatives</h2>
          <p>The core component of the Velocity Sales process is working through the Seven Imperatives process for each deal. Your salespeople should be updating win cards for each opportunity daily.</p>
          <p>When your salespeople use the Seven Imperatives framework for each every opportunity, you'll gain valuable insights into deal progress, can quickly identify risks, and will be able to coach and communicate more effectively.</p>
        </div>
      )
    }
    else{
      return (
        <div className="modal-content">
          <div className="message-icons">
            <div className="message-icon active">{getIcon('imperatives')}</div>
          </div>
          <h2>Seven Imperatives</h2>
          <p>The core component of the Velocity Sales process is working through the Seven Imperatives process for each deal. You should be updating each Seven Imperatives "Win Card" as you make progress on each Opportunity.</p>
          <p>Using the Seven Imperatives framework for each of your opportunities is proven to help you sell more effectively, and gives you a common language for communicating deal progress and risks with leaders and colleagues.</p>
        </div>
      )
    }
  }

  renderInitialMessage(){
    const coachingIQDisabled = this.coachingIQDisabled();

    if(currentUserIsManager()){
      return (
        <div className="modal-content">
          <div className="message-icon">{getIcon('predictive')}</div>
          <h2>Welcome to Velocity</h2>
          <p>This application is designed to augment your organization's sales training and help you develop your salespeople. Through use of this application and the Velocity Sales process, you should expect to achieve the following in the upcoming months:</p>
          <ul>
            <li>Develop behaviors and skills of your salespeople</li>
            <li>Shorten deal time-to-close and increase win rate</li>
            <li>Improve coaching effectiveness and reception</li>
            <li>More accurate forecasting for your pipeline</li>
            <li>Share a common sales language among other leaders</li>
          </ul>
          {!coachingIQDisabled &&
            <p>We'll get started by going over the basic concepts behind the Velocity Sales system. You and your salespeople will be responsible for completing tasks <b>quarterly, weekly, and daily</b>, so let's review what those tasks look like now.</p>
          }
          {coachingIQDisabled &&
            <p>Let's briefly go over the Seven Imperatives process, which you will be assisting your salespeople in completing for every deal that satisfies the filters your organization has specified</p>
          }
        </div>
      );
    }
    else{
      return (
        <div className="modal-content">
          <div className="message-icon">{getIcon('predictive')}</div>
          <h2>Welcome to Velocity</h2>
          <p>This application is designed to augment your organization's sales training and help you develop as a salesperson. Through this application and the training you will receive from your sales leaders, you should expect to achieve the following in the upcoming months:</p>
          <ul>
            <li>Develop high performing behaviors and sales skills</li>
            <li>Improve deal time-to-close and win rate</li>
            {/*<li>Improved forecasting for your pipeline</li>*/}
            <li>Communicate deals more effectively with colleagues and leaders</li>
            {/*<li>Share a common sales language</li>*/}
          </ul>
          {!coachingIQDisabled &&
            <p>We'll get started by going over the basic concepts behind the Velocity Sales system. You and your manager will be responsible for completing tasks <b>quarterly, weekly, and daily</b>, so let's review what those tasks look like now.</p>
          }
          {coachingIQDisabled &&
            <p>Let's briefly go over the Seven Imperatives process, which you will be completing for every deal that satisfies the filters your organization has specified</p>
          }
        </div>
      );
    }
  }

  //<p>Also, keep in mind that this application is still in Beta. So if you come across anything not working as intended, please tell us what's up so we can fix it ASAP :)</p>

  renderGetStarted(){
    if(currentUserIsManager()){
      return (
        <div className="modal-content">
          <div className="message-icon">{getIcon('rate')}</div>
          <h2>One last thing</h2>
          <p>As you continue to use this application and the Velocity sales process, <b>please reach out to us</b> if you feel like we can help you accomplish these objectives better. You can send us feedback at any time using the <b className="color-pink">Submit Feedback</b> button in the bottom left corner of your screen.</p>
          {!this.coachingIQDisabled() &&
            <p>Next, let's go to your teams page where you can complete initial talent evaluations for your employees, and then work on setting up quarterly goals for their sprints and helping them create action plans.</p>
          }
        </div>
      )
    }
    else{
      return (
        <div className="modal-content">
          <div className="message-icon">{getIcon('rate')}</div>
          <h2>One last thing</h2>
          <p>As you continue to use this application and the Velocity sales process, <b>please reach out to us</b> if you feel like we can help you accomplish these objectives better. You can send us feedback at any time using the <b className="color-pink">Submit Feedback</b> button in the bottom left corner of your screen.</p>
          {!this.coachingIQDisabled() &&
            <p>After completing the talent evaluation, your manager should be scheduling a time to meet to review your talent evaluation and make a plan for the quarter. For now, let's get started on that Talent Evaluation...</p>
          }
        </div>
      )
    }
  }

  renderModalActionsForStep(currentStep){

    const coachingIQDisabled = this.coachingIQDisabled();

    return(
      <div className="modal-actions">
        {currentStep === 1 &&
          <button onClick={this.next.bind(this)} className="button primary">Next</button>
        }

        {(currentStep === 2 || currentStep === 3 || currentStep === 4 || currentStep === 5) &&
          <button onClick={this.prev.bind(this)} className="button left grey-button">Back</button>
        }
        {!coachingIQDisabled && (currentStep === 2 || currentStep === 3 || currentStep === 4) &&
          <button onClick={this.next.bind(this)} className="button primary">Next</button>
        }
        {!coachingIQDisabled && currentStep === 5 &&
          <button onClick={this.finishWelcome.bind(this)} className="button primary">Get Started</button>
        }
        {coachingIQDisabled && currentStep === 2 &&
          <button onClick={this.next.bind(this)} className="button primary">Next</button>
        }
        {coachingIQDisabled && currentStep === 3 &&
          <button onClick={this.finishWelcome.bind(this)} className="button primary">Get Started</button>
        }

      </div>
    );
  }

  renderStepProgress(){

    const { currentStep } = this.state;

    const coachingIQDisabled = this.coachingIQDisabled();

    return(
      <div className="welcome-progress">
        {_.map(coachingIQDisabled ? [1,2,3] : [1,2,3,4,5], thisStep => {
          return(
            <div className={`step ${currentStep === thisStep ? 'active' : (currentStep > thisStep ? 'done' : '')}`}></div>
          )
        })}
      </div>
    )
  }

  skipWelcome(){

    const userDataToUpdate = {
      _id: this.props.user._id,
      welcomeModalSkipped: true
    }

    this.props.updateUser(userDataToUpdate);
    this.finishWelcome();
  }

  renderSkipAction(){
    return (
      <div
        onClick={this.skipWelcome.bind(this)}
        className="skip-welcome">Skip tutorial</div>
    )
  }

  renderCurrentStep(){
    const { currentStep} = this.state;
    const coachingIQDisabled = this.coachingIQDisabled();

    if(coachingIQDisabled){
      if(currentStep === 1){
        return this.renderInitialMessage();
      }
      else if(currentStep === 2){
        return this.renderSevenImperativesPreview();
      }
      else if(currentStep === 3){
        return this.renderGetStarted();
      }
    }
    else{
      if(currentStep === 1){
        return this.renderInitialMessage();
      }
      else if(currentStep === 2){
        return this.renderQuarterlyPreview();
      }
      else if(currentStep === 3){
        return this.renderWeeklyPreview();
      }
      else if(currentStep === 4){
        return this.renderDailyPreview();
      }
      else if(currentStep === 5){
        return this.renderGetStarted();
      }
    }
  }

  render(){

    const { currentStep, welcomeComplete } = this.state;

    if(welcomeComplete){
      if(currentUserIsManager()){
        return <Redirect to="/teams" />
      }
      else if(this.props.user.pendingAssessment && !this.props.user.pendingAssessment.status){
        return <Redirect to="/strengths" />
      }
      else{
        if(this.coachingIQDisabled()){
          return <Redirect to="/imperatives" />
        }
        else{
          if(this.competenciesEnabled()){
            return <Redirect to="/salesCompetencies" />
          }
          else{
            return <Redirect to="/talents" />
          }
        }
      }
    }

    if(!this.state.visible){
      return null;
    }

    return (
      <div className={`modal welcome full-screen`}>
        <div
          className="modal-container"
          ref={elem => { this.container = elem; }}
        >
          {this.renderCurrentStep()}
          {this.renderStepProgress()}

          {this.renderModalActionsForStep(currentStep)}

          {currentStep === 1 && this.renderSkipAction()}
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    organization: state.organization.data,
    user: state.user,
  }
}

export default connect(mapStateToProps, { updateUser })(WelcomeModal);



// WEBPACK FOOTER //
// ./src/components/modals/welcome.js